export const magazine = {
	GET_LAST_MAGAZINE: "magazine/getLast",
	CHANGE_MAGAZINE: "magazine/change",
}

export default magazine
